import { query } from "../../../erd-editor-schema/dist/query/index.js";
import { ReferentialAction } from "../../../constants/schema.js";
import { arrayHas } from "../../../utils/arrayHas.js";
import { createAction } from "../../../r-html/dist/store/index.js";
import { ActionType } from "./actions.js";
import { createRelationship } from "../../../utils/collection/relationship.entity.js";
//#region src/engine/modules/relationship/atom.actions.ts
var addRelationshipAction = createAction(ActionType.addRelationship);
var addRelationship = ({ doc, collections, lww }, { payload: { id, relationshipType, onDelete, onUpdate, start, end }, version }, { clock }) => {
	const safeVersion = version ?? clock.getVersion();
	query(collections).collection("relationshipEntities").addOne(createRelationship({
		id,
		relationshipType,
		onDelete: onDelete ?? ReferentialAction.none,
		onUpdate: onUpdate ?? ReferentialAction.none,
		start: {
			tableId: start.tableId,
			columnIds: start.columnIds
		},
		end: {
			tableId: end.tableId,
			columnIds: end.columnIds
		}
	})).addOperator(lww, safeVersion, id, () => {
		if (!arrayHas(doc.relationshipIds)(id)) doc.relationshipIds.push(id);
	});
};
var removeRelationshipAction = createAction(ActionType.removeRelationship);
var removeRelationship = ({ doc, collections, lww }, { payload: { id }, version }, { clock }) => {
	const safeVersion = version ?? clock.getVersion();
	query(collections).collection("relationshipEntities").removeOperator(lww, safeVersion, id, () => {
		const index = doc.relationshipIds.indexOf(id);
		if (index !== -1) doc.relationshipIds.splice(index, 1);
	});
};
var changeRelationshipTypeAction = createAction(ActionType.changeRelationshipType);
var changeRelationshipType = ({ collections, lww }, { payload: { id, value }, version }, { clock }) => {
	const safeVersion = version ?? clock.getVersion();
	const collection = query(collections).collection("relationshipEntities");
	collection.replaceOperator(lww, safeVersion, id, "relationshipType", () => {
		collection.updateOne(id, (relationship) => {
			relationship.relationshipType = value;
		});
	});
};
var changeRelationshipOnDeleteAction = createAction(ActionType.changeRelationshipOnDelete);
var changeRelationshipOnDelete = ({ collections, lww }, { payload: { id, value }, version }, { clock }) => {
	const safeVersion = version ?? clock.getVersion();
	const collection = query(collections).collection("relationshipEntities");
	collection.replaceOperator(lww, safeVersion, id, "onDelete", () => {
		collection.updateOne(id, (relationship) => {
			relationship.onDelete = value;
		});
	});
};
var changeRelationshipOnUpdateAction = createAction(ActionType.changeRelationshipOnUpdate);
var changeRelationshipOnUpdate = ({ collections, lww }, { payload: { id, value }, version }, { clock }) => {
	const safeVersion = version ?? clock.getVersion();
	const collection = query(collections).collection("relationshipEntities");
	collection.replaceOperator(lww, safeVersion, id, "onUpdate", () => {
		collection.updateOne(id, (relationship) => {
			relationship.onUpdate = value;
		});
	});
};
var changeRelationshipColumnsAction = createAction(ActionType.changeRelationshipColumns);
var COLUMNS = "columns";
var toColumnsKey = (startColumnIds, endColumnIds) => JSON.stringify([startColumnIds, endColumnIds]);
var namesOtherTables = (relationship, { start, end }) => relationship.start.tableId !== start.tableId || relationship.end.tableId !== end.tableId;
var changeRelationshipColumns = ({ collections, lww }, { payload: { id, start, end }, version }, { clock }) => {
	const safeVersion = version ?? clock.getVersion();
	const collection = query(collections).collection("relationshipEntities");
	const relationship = collection.selectById(id);
	if (relationship && namesOtherTables(relationship, {
		start,
		end
	})) return;
	if (relationship && (lww[id]?.[3][COLUMNS] ?? -1) === safeVersion && toColumnsKey(start.columnIds, end.columnIds) <= toColumnsKey(relationship.start.columnIds, relationship.end.columnIds)) return;
	collection.replaceOperator(lww, safeVersion, id, COLUMNS, () => {
		collection.updateOne(id, (value) => {
			value.start.columnIds = [...start.columnIds];
			value.end.columnIds = [...end.columnIds];
		});
	});
};
var relationshipReducers = {
	[ActionType.addRelationship]: addRelationship,
	[ActionType.removeRelationship]: removeRelationship,
	[ActionType.changeRelationshipType]: changeRelationshipType,
	[ActionType.changeRelationshipOnDelete]: changeRelationshipOnDelete,
	[ActionType.changeRelationshipOnUpdate]: changeRelationshipOnUpdate,
	[ActionType.changeRelationshipColumns]: changeRelationshipColumns
};
var actions = {
	addRelationshipAction,
	removeRelationshipAction,
	changeRelationshipTypeAction,
	changeRelationshipOnDeleteAction,
	changeRelationshipOnUpdateAction,
	changeRelationshipColumnsAction
};
//#endregion
export { actions, addRelationshipAction, changeRelationshipColumnsAction, changeRelationshipOnDeleteAction, changeRelationshipOnUpdateAction, changeRelationshipTypeAction, namesOtherTables, relationshipReducers, removeRelationshipAction };
